import { Component, OnInit, Input, ElementRef, ViewChild, ViewChildren, QueryList, forwardRef, HostListener, Output, EventEmitter, ContentChild, TemplateRef, OnDestroy, NgZone } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgxSelectboxMayService } from './ngx-selectbox-may.service';
import { NGXSelectMayConfigs, NGXSelectMayRow } from './ngx-selectbox-may-configs';

@Component({
  selector: 'ngx-selectbox-may',
  host: {
    '(document:click)': 'onClickOutside($event)',
    '(window:resize)': 'onWindowResize($event)'
  },
  templateUrl: './ngx-selectbox-may.component.html',
  styleUrls: ['./ngx-selectbox-may.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgxSelectboxMayComponent),
      multi: true,
    }
  ]
})
export class NgxSelectboxMayComponent implements OnInit, ControlValueAccessor {

  dropdownRows: Array<NGXSelectMayRow> = [];
  configs: NGXSelectMayConfigs = new NGXSelectMayConfigs();
  selectedRows: Array<NGXSelectMayRow> = [];
  show_items: boolean = false;
  searchText: string = "";
  isEnable:boolean = true;
  propagateChange = (_: any) => { };
  propagateOnTouch = (_: any) => { };

  @Input("items")
  set items(items: any[]) {
    this.createDropdownRows(items);
  }

  @Input("css-class")
  set cssClass(cssClass: string) {
    this.configs.cssClass = cssClass;
  }

  @Input("value-field")
  set valueField(valueField: string) {
    this.configs.valueField = valueField;
  }

  @Input("label-field")
  set labelField(labelField: string) {
    this.configs.labelField = labelField;
    this.reconfigureLabelsAndValues();
  }

  @Input("placeholder")
  set placeholder(placeholder: string) {
    this.configs.placeholderText = placeholder;
  }

  @Input("empty-text")
  set emptyText(emptyText: string) {
    this.configs.emptyText = emptyText;
  }

  @Input("show-empty-text")
  set showEmptyResultText(showEmptyText: boolean) {
    this.configs.showEmptyResultsLabel = showEmptyText;
  }

  @Input("is-multi")
  set isMulti(isMulti: boolean) {
    this.configs.isMultiSelect = isMulti;
  }

  _isLoading: boolean;
  @Input("is-loading")
  set isLoading(isLoading: boolean) {
    this._isLoading = isLoading;
  }

  _loadingText: string;
  @Input("loading-text")
  set loadingText(loadingText: string) {
    this._loadingText = loadingText;
  }

  @Output("search-keyup") onKeyUp = new EventEmitter();
  @Output("on-select-item") onSelect = new EventEmitter();
  @Output("on-blur") onBlur = new EventEmitter();

  @ViewChild('search_field') searchField: ElementRef;
  @ViewChildren("li_item") listItems: QueryList<ElementRef>;
  itemWindow: ElementRef;

  @ContentChild('actionTemplate') actionTemplate: TemplateRef<ElementRef>;
  constructor(private _selectboxref: ElementRef, private selectboxService: NgxSelectboxMayService) {

  }

  ngOnInit() {
  }


  createDropdownRows(items: any[]) {
    this.dropdownRows = this.selectboxService.createDropdownRows(items, this.configs);
    this.setValuesPassedExternal(this.ngModelValue);
  }

  reconfigureLabelsAndValues() {
    this.selectboxService.reconfigureDropdownRowLabelsAndValues(this.dropdownRows, this.configs);
  }

  getSelectboxLabel() {
    let label = this.selectboxService.createDropdownLabel(this.configs, this.selectedRows);
    return label ? label : this.configs.placeholderText;
  }

  getEmptyTextLabel() {
    return this.configs.emptyText ? this.configs.emptyText : NGXSelectMayConfigs.EMPTY_TEXT;
  }

  getLoadingText() {
    return this._loadingText ? this._loadingText : NGXSelectMayConfigs.LOADING_TEXT;
  }

  onClickSelectBox() {
    this.showItemsWindow();
  }

  getActiveClass() {
    return NGXSelectMayConfigs.ROW_ACTIVE_CLASS;
  }

  showItemsWindow() {
    this.show_items = true;
  }

  hideItemsWindow() {
    this.onBlur.emit(this.searchText);
    this.resetFilters();
    this.show_items = false;
  }

  onRemoveClick() {
    this.selectboxService.unselectAllSelectedRows(this.dropdownRows);
    this.selectedRows = [];
    this.publishValue();
  }

  onSearchKeydown(e) {
    if (e.key == "Escape") {
      this.hideItemsWindow();
    }
    //Up and Down arrow events
    if (e.keyCode == 38 || e.keyCode == 40) {
      e.preventDefault();
    }
  }

  onSearchKeyup(e) {
    if (e.keyCode == 38 || e.keyCode == 40 || e.key == "Escape") {
      e.preventDefault();
    }
    else {
      this.onKeyUp.emit(this.searchText);
    }
  }

  resetFilters() {
    this.searchText = "";
  }

  onClickItem(row: NGXSelectMayRow, index: number) {
    if (this.configs.isMultiSelect) {

    } else {
      this.selectedRows = this.selectboxService.setSelectedItems(this.configs, this.selectedRows, this.dropdownRows, row);
      this.onSelect.emit(row.data);
      this.hideItemsWindow();
    }
    this.publishValue();
  }

  publishValue() {
    let values = this.selectedRows.map(r => r.value);
    if (this.configs.isMultiSelect) {
      this.propagateChange(values);
    } else {
      this.propagateChange(values.length > 0 ? values[0] : "");
    }
  }

  setValuesPassedExternal(obj: any) {
    if (this.configs.isMultiSelect) {
      this.selectedRows = this.selectboxService.selectItemsByValue(this.dropdownRows, obj);
    } else {
      this.selectedRows = this.selectboxService.selectItemByValue(this.dropdownRows, obj);
    }
  }

  /*
  *
  * On Item browse open window begin & document outside click event Begins
  * 
  */

  @ViewChild('item_window') set content(content: ElementRef) {
    this.itemWindow = content;
    // this.positionWindow();
    this.focusToSearchField();
    this.scrollToSelectedItem();
  }

  positionWindow() {
    if (this.searchField) {
      const selectBoxRef = this._selectboxref.nativeElement;
      var viewportOffset = selectBoxRef.getBoundingClientRect();
      console.log(viewportOffset);
      this.itemWindow.nativeElement.setAttribute('style', 'width: ' + (selectBoxRef.firstChild.offsetWidth + 3) + 'px; top: ' + (viewportOffset.top - 5) + 'px; margin-left: -12px;');
    }
  }

  focusToSearchField() {
    if (this.searchField) {
      this.searchField.nativeElement.focus();
    }
  }

  scrollToSelectedItem() {
    this.listItems.forEach(li => {
      if (li.nativeElement.classList.contains(NGXSelectMayConfigs.ROW_ACTIVE_CLASS)) {
        const scrollLi = li.nativeElement;
        this.itemWindow.nativeElement.getElementsByTagName("ul")[0].scrollTop = scrollLi.offsetTop - (scrollLi.offsetHeight + 20);
      }
    });
  }

  onClickOutside(e) {
    if (!this._selectboxref.nativeElement.contains(event.target) && this.show_items) {
      this.hideItemsWindow();
    }
  }

  onWindowResize(e) {
    // this.positionWindow();
  }

  setDisable(){
    this.hideItemsWindow();
    this.isEnable = false;
  }

  setEnable(){
    this.isEnable = true;
  }

  /*
  *
  * On Item browse open window begin & document outside click event Ends
  * 
  */



  /*
  //on document key up and down

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if((event.keyCode == 38 || event.keyCode == 40) && this.itemWindow && this.clonedItems.length > 0){
        var index = -1;
        var ul = this.itemWindow.nativeElement.getElementsByTagName("ul")[0]
        var selectedLi = ul.getElementsByClassName('selected')[0];
        if(selectedLi){
          index = Array.prototype.indexOf.call(ul.children, selectedLi);
          selectedLi.classList.remove("selected");
        }
        //up arrow
        if(event.keyCode == 38){
          index = ((index - 1) < 0) ? 0 : (index - 1);
        }
        //down arrow
        else{
          index = ((index + 1) > (ul.children.length -1)) ? (ul.children.length -1) :  (index + 1);
        }
        ul.children[index].classList.add("selected");
        ul.scrollTop = ul.children[index].offsetTop - (ul.children[index].offsetHeight + 20);
    }
  }
*/
  //Control value accessor begins
  //Store external value once items got loaded in to dropdown
  ngModelValue: any;
  writeValue(obj: any): void {
    this.ngModelValue = obj;
    this.setValuesPassedExternal(obj);
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.propagateOnTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    console.log(isDisabled, "set disable");
    if(isDisabled){
      this.setDisable();
    }else{
      this.setEnable();
    }
  }
  //Control value accessor ends
}